module.exports = "/img/_/_/_/assets/images/creeper/book/common//38.jpg?ab1d5f1d352b56beaaca310268a710f7";